(() => {
'use strict';
const $f070ca621ebf3c06$var$getStoredTheme = ()=>localStorage.getItem('theme');
const $f070ca621ebf3c06$var$setStoredTheme = (theme)=>localStorage.setItem('theme', theme);
const $f070ca621ebf3c06$var$removeStoredTheme = ()=>localStorage.removeItem('theme');
// Gets the theme from storage or the media query
const $f070ca621ebf3c06$var$getPreferredTheme = ()=>{
    const storedTheme = $f070ca621ebf3c06$var$getStoredTheme();
    if (storedTheme) return storedTheme;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};
// Set the data attribute
const $f070ca621ebf3c06$var$setTheme = (theme)=>{
    document.documentElement.setAttribute('data-color-scheme', theme);
    // Dispatch a custom event that we can use to react to the theme change
    const event = new CustomEvent('colorModeChange', {
        detail: theme
    });
    document.dispatchEvent(event);
};
/**
 * Event Listeners
 */ // React to changes to the prefers-color-scheme media query
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', ()=>{
    $f070ca621ebf3c06$var$removeStoredTheme();
    $f070ca621ebf3c06$var$setTheme($f070ca621ebf3c06$var$getPreferredTheme());
});
// React to changes to the toggle
window.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('[data-color-scheme-toggle]').forEach((toggle)=>{
        toggle.addEventListener('click', ()=>{
            const targetTheme = document.documentElement.getAttribute('data-color-scheme') === 'dark' ? 'light' : 'dark';
            $f070ca621ebf3c06$var$setStoredTheme(targetTheme);
            $f070ca621ebf3c06$var$setTheme(targetTheme);
        });
    });
});
// Set the initial theme
$f070ca621ebf3c06$var$setTheme($f070ca621ebf3c06$var$getPreferredTheme());
window.getColorScheme = ()=>document.documentElement.getAttribute('data-color-scheme');

})();
//# sourceMappingURL=darkmode.min.js.map
